<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { Accordion } from './internal/';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = withDefaults(defineProps<{
    class?: HTMLAttributes['class']
    type?: 'single' | 'multiple'
}>(), {
    class: '',
    type: 'single',
});

const modelValue = defineModel<string | string[]>('modelValue');
</script>

<template>
    <Accordion
        v-model="modelValue"
        :class="props.class"
        :type="props.type"
        collapsible
    >
        <slot></slot>
    </Accordion>
</template>
